import { TransactionTime } from "@ctypes";
import { useTransactions } from "./useTransactions";

export const useUpcomingTransactions = () => {
  return useTransactions({
    time: TransactionTime.Upcoming,
  });
};
